export default "__VITE_ASSET__5ef5177b__"